<ng-container *ngIf="!connectWalletVisible">
    <!-- NetWorth -->
    <div *ngIf="!top3ERC20Tokens || top3ERC20Tokens.length" class="bg-badge p-4 md:p-8 rounded-xl">
        <ng-container *ngIf="!top3ERC20Tokens">
            <nz-skeleton [nzActive]="true"></nz-skeleton>
        </ng-container>

        <ng-container *ngIf="top3ERC20Tokens?.length">
            <div class="mb-4 md:mb-6 text-sm font-semibold md:text-base">Top 3</div>
            <div class="flex text-sm flex-col gap-y-4 justify-start items-start md:flex-row md:justify-between md:items-center">
                <div *ngFor="let token of top3ERC20Tokens" class="flex-start-center w-full gap-x-2">
                    <div class="relative">
                        <img [src]="token.token_logo_url" class="w-8 h-8 object-contain rounded-full bg-black bg-opacity-5" alt="" />
                        <img
                            *ngIf="token.chain_name !== ChainEnum.ETHEREUM || token.token_symbol !== 'ETH'"
                            [src]="getChainInfo(token.chain_name)?.imgUrl"
                            class="absolute -top-1 -right-1 w-3 h-3 rounded-full"
                            alt=""
                        />
                    </div>
                    <div class="max-md:flex-1 max-md:flex-between-center">
                        <div>{{token.token_symbol}}</div>
                        <div>
                            ${{tokenData.get(token.chain_name + token.token_symbol)?.value | kmb2:2}} ({{(tokenData.get(token.chain_name +
                            token.token_symbol)?.percent) | percent}})
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <div *ngIf="erc20Tokens?.length" class="inscription-section-content mt-4">
        <nz-table
            #erc20Table
            [nzData]="erc20Tokens"
            nzTableLayout="fixed"
            [nzHideOnSinglePage]="true"
            [nzScroll]="{x:'800px'}"
            [nzPaginationType]="'small'"
            class="!rounded-xl !overflow-hidden"
        >
            <thead>
                <tr>
                    <th [nzWidth]="'200px'">Token</th>
                    <th>Price</th>
                    <th>Amount</th>
                    <th>USD Value</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of erc20Table.data">
                    <td>
                        <div class="flex justify-start items-center gap-x-2">
                            <div class="relative">
                                <img [src]="data.token_logo_url" class="w-6 h-6 object-contain rounded-full bg-black bg-opacity-5" alt="" />
                                <img
                                    *ngIf="data.chain_name !== ChainEnum.ETHEREUM || data.token_symbol !== 'ETH'"
                                    [src]="getChainInfo(data.chain_name)?.imgUrl"
                                    class="absolute -top-1 -right-1 w-3 h-3 rounded-full"
                                    alt=""
                                />
                            </div>

                            <div class="max-w-[200px] truncate">{{data.token_symbol }}</div>
                        </div>
                    </td>
                    <td>
                        <ng-container *ngIf="data.price === 0 || data.price > 0;else noPlaceholder"> ${{data.price | number:'1.0-2'}} </ng-container>
                    </td>
                    <td>{{data.balance < 0.0001 ? '< 0.0001' : (data.balance | number:'1.0-4')}}</td>
                    <td>${{data.balance * (data.price || 0) | number:'1.0-2'}}</td>
                </tr>
            </tbody>
        </nz-table>
    </div>

    <div *ngIf="top3ERC20Tokens && !top3ERC20Tokens.length" class="w-[120px] mx-auto text-center text-[#b5b5b5]">
        <img class="mx-auto w-36" src="/assets/imgs/no-data/no-data.png" alt="No Data" />
        <div>No Data</div>
    </div>

    <ng-template #noPlaceholder>--</ng-template>
</ng-container>

<div *ngIf="connectWalletVisible">
    <!-- TG Connect Wallet -->
    <div class="text-center pb-10 text-[#b5b5b5]">
        <img class="mx-auto w-32" src="/assets/imgs/no-data/no-data.png" alt="No Data" />
        <div>Please connect your wallet first.</div>
        <button nz-button nzType="primary" class="mt-4 !h-[34px] !w-[137px]" nzSize="small" (click)="commonService.showLogInModal('Connect New Wallet')">
            <span class="colorful-text">Connect Wallet</span>
        </button>
    </div>
</div>
